import { CustomiserModal } from './customiser-modal';

const getTooltipMarkup = (data:string) => {
  const template = document.createElement('template');

  template.innerHTML = `
    <style>
      :host {
        display: block;
        text-align: center;
      }

      .tooltip-button {
        display: flex;
        gap: 8px;
        justify-content: center;
        align-items: center;
        padding: 8px 15px;
        margin: 24px auto 0;
        font-size: 14px;
        font-family: 'TTNorms Font', Helvectica, sans-serif;
        border-radius: 10px;
        border: none;
        cursor: pointer;
        background-color: #F1EBE7;
        color: #163021;
      }

      .tooltip-button svg {
        width: 20px;
        height: 20px;
      }

      @media only screen and (min-width: 1100px) {

        .tooltip-button {
          margin-top: 0;
          font-size: 1rem;
          line-height: 24px;
          padding: .5rem 1rem;
          gap: 6px;
          transition: all 500ms;
          margin-left: 0;
        }

        .tooltip-button:hover svg circle {
          fill: #163021;
        }

        .tooltip-button:hover svg path {
          stroke: #fff;
        }
      }

      @media only screen and (min-width: 1750px) {
      
        .tooltip-button {
          font-size: 1.125rem;
          line-height: 1.5rem;
        }

        .tooltip-button svg {
          width: 20px;
          height: 20px;
        }
      }
    </style>
    
    <button class="tooltip-button">
      <span>${data}</span>
      <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><circle cx="9" cy="9" r="6.75" stroke="#163021"/><path d="M6 9h6M9 6v6" stroke="#163021" stroke-linecap="round"/></svg>
    </button>

    <slot></slot>
  `;
  
  return template;
}

export class CustomiserTooltip extends HTMLElement {
  private data:string;
  private modal:CustomiserModal | null = null;
  private modalTrigger:HTMLButtonElement | null = null;

  constructor() {
    super();

    const data = this.getAttribute('data');
    if (data) {
      this.data = data;
      const shadowRoot = this.attachShadow({ mode: 'open' });
      const template = getTooltipMarkup(this.data);
      shadowRoot.appendChild(template.content.cloneNode(true));
    } else {
      return;
    }

    if (this.shadowRoot) {
      this.modal = this.querySelector('customiser-modal');
      this.modalTrigger = this.shadowRoot.querySelector('.tooltip-button');
  
      if (!this.modal) {
        console.error('You need to render some modal content in here!', this);
      }
  
      this.modalTrigger?.addEventListener('click', (e) => {
        this.triggerModal();
      });
    }
  }

  triggerModal() {
    this.modal?.setVisibility(true);
  }
}

if (!customElements.get('customiser-tooltip')) {
  customElements.define('customiser-tooltip', CustomiserTooltip);
}